var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34973 16.2556C3.94129 16.5783 3.52018 16.5865 3.08641 16.2801C2.65182 15.9738 2.51132 15.5739 2.6649 15.0805L4.06913 10.5112L0.494823 7.95886C0.0692224 7.65252 -0.0627055 7.25266 0.099039 6.75925C0.260784 6.26503 0.605512 6.01792 1.13322 6.01792H5.54934L6.97931 1.26974C7.06426 1.01487 7.20028 0.823719 7.38735 0.696284C7.57441 0.568032 7.77864 0.503906 8.00001 0.503906C8.22139 0.503906 8.42561 0.568032 8.61268 0.696284C8.79975 0.823719 8.93576 1.01487 9.02072 1.26974L10.4507 6.01792H14.8668C15.3945 6.01792 15.7392 6.26503 15.901 6.75925C16.0627 7.25266 15.9308 7.65252 15.5052 7.95886L11.9309 10.5112L13.3351 15.0805C13.4887 15.5739 13.3482 15.9738 12.9136 16.2801C12.4798 16.5865 12.0587 16.5783 11.6503 16.2556L8.00001 13.4729L4.34973 16.2556Z",
    fill: "#FDA700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4f451e6f58609a062bbefd62dffec046.svg";
export { ForwardRef as ReactComponent };